import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ea081d8")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_toolbar, null, {
        default: _withId(() => [
          (_ctx.isLoyaltyGuest)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                size: "small",
                fill: "transparent",
                href: "/loyalty/guest",
                routerDirection: "backward"
              }))
            : (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                size: "small",
                fill: "transparent",
                href: "/orders",
                routerDirection: "backward"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    class: "close-icon",
                    icon: "/assets/icons/close.svg"
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { "scroll-y": false }, {
        default: _withId(() => [
          _createVNode(_component_ion_router_outlet)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})